// extracted by mini-css-extract-plugin
export var clickableWrapper = "_33-2";
export var placeholderIcon = "_33-3";
export var thumbnailCanvas = "_33-1";
export var thumbnailWrapper = "_33-0";